/* eslint-disable react/no-danger */
import Header from '@/kenwood/configurator/components/Header';
import PromoBanner from '@/kenwood/configurator/components/PromoBanner';
import Menu from '@/kenwood/configurator/components/accessories/Menu';
import { useConfiguratorContext } from '@/kenwood/configurator/context';
import useProductData from '@/kenwood/configurator/hooks/useProductData';
import useSetupStep2 from '@/kenwood/configurator/hooks/useSetupStep2';
import {
  pushProductChange,
  pushStep2,
} from '@/utils/Controllers/GTM/Operations/Kenwood/Configurator';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const backArrowBranded = 'arrow-branded.svg';
const backArrowWhite = 'arrow-white.svg';

const Step2 = () => {
  const { t } = useTranslation();
  useProductData();

  const [
    { isOwner, stepTwoMenuOpen, selectedProduct, selectedCategory },
    { setStepTwoMenuOpen, setChangeConfigOpen },
  ] = useConfiguratorContext();

  const { overviewImage, overviewAlt, productTitle } = useSetupStep2();

  const [backHovered, setBackHovered] = useState(false);

  const changeModelHandler = () => {
    pushProductChange(isOwner, selectedProduct?.name || selectedCategory?.name);
    setChangeConfigOpen('');
  };

  useEffect(() => {
    if (selectedProduct || selectedCategory) {
      pushStep2(isOwner);
    }
  }, [selectedProduct, selectedCategory]);

  if (!selectedProduct && !selectedCategory) {
    return null;
  }

  return (
    <div>
      <Header />
      <div className='ken-configurator__step'>
        <div className='ken-configurator__step-two'>
          <div className='ken-configurator__step-two-menu'>
            {/* Accessories menu Component */}
            {(selectedProduct || selectedCategory) && <Menu />}
          </div>
          <div className='ken-configurator__step-two-summary'>
            <div className='ken-configurator__step-two-overview'>
              {/* Mobile Overview layout */}
              <div
                className={`ken-configurator__step-two-overview-mobile ${
                  stepTwoMenuOpen ? '-mobile-closed' : ''
                }`}
              >
                <div className='ken-configurator__step-two-overview-mobile-title'>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: t(
                        `configurator:configurator.step2.title.${
                          isOwner ? 'owner' : 'wannabe'
                        }`,
                        {
                          productTitle: `<span>${productTitle}</span>`,
                        },
                      ),
                    }}
                  />
                </div>
                <div className='ken-configurator__step-two-overview-mobile-img-wrapper'>
                  <img
                    src={overviewImage}
                    alt={overviewAlt}
                    className='ken-configurator__step-two-overview-mobile-img'
                  />
                </div>
                <div className='ken-configurator__step-two-overview-mobile-change-wrapper'>
                  <button
                    type='button'
                    className='ken-configurator__step-two-overview-mobile-change'
                    onClick={changeModelHandler}
                  >
                    {t('configurator:configurator.change.model')}
                  </button>
                </div>
                <div className='ken-configurator__step-two-overview-mobile-cta-wrapper'>
                  <button
                    type='button'
                    className='ken-button--secondary ken-configurator__step-two-overview-mobile-cta-back'
                    onClick={changeModelHandler}
                    onMouseEnter={() => setBackHovered(true)}
                    onMouseLeave={() => setBackHovered(false)}
                  >
                    <img
                      src={`${
                        DLG.config.distResourcePath
                      }/assets/images/kenwood/configurator/${
                        backHovered ? backArrowWhite : backArrowBranded
                      }`}
                      alt={t('configurator:configurator.alt.back')}
                      className='ken-configurator__step-two-overview-mobile-cta-back-img'
                    />
                  </button>
                  <button
                    type='button'
                    className='ken-button--primary ken-configurator__step-two-overview-mobile-cta-menu'
                    onClick={() => setStepTwoMenuOpen(true)}
                  >
                    {t('configurator:configurator.choose.accessories')}
                  </button>
                </div>
              </div>

              {/* Desktop Overview layout */}
              <div className='ken-configurator__step-two-overview-desktop'>
                <div className='ken-configurator__step-two-overview-desktop-img-wrapper'>
                  <img
                    src={overviewImage}
                    alt={overviewAlt}
                    className='ken-configurator__step-two-overview-desktop-img'
                  />
                </div>
                <div className='ken-configurator__step-two-overview-desktop-content-wrapper'>
                  <div
                    className='ken-configurator__step-two-overview-desktop-title'
                    dangerouslySetInnerHTML={{
                      __html: t(
                        `configurator:configurator.step2.title.${
                          isOwner ? 'owner' : 'wannabe'
                        }`,
                        {
                          productTitle: `<span>${productTitle}</span>`,
                        },
                      ),
                    }}
                  />
                  <button
                    className='ken-configurator__change-config-cta'
                    type='button'
                    onClick={changeModelHandler}
                  >
                    {t('configurator:configurator.changeconfig.button.label')}
                  </button>
                  <PromoBanner />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step2;
